<template>
  <table class="restorations-table table table-bordered text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th rowspan="2">
          <span v-b-popover.hover.top="'Номер восстановления у игрока'">
            №
          </span>
        </th>
        <th rowspan="2">
          <span v-b-popover.hover.top="'Идентификатор восстановления'">
            Ид
          </span>
        </th>
        <th rowspan="2">Время</th>
        <th colspan="3">Инициатор</th>
        <th colspan="3">Целевой профиль</th>
      </tr>
      <tr>
        <th>ext id</th>
        <th>ид</th>
        <th>состояние</th>
        <th>idType</th>
        <th>idVal</th>
        <th>ид</th>
      </tr>
    </thead>
    <tr
      v-for="(restoration, index) in restorations"
      :key="restoration.Id"
    >
      <td class="text-right">
        {{ getEventNumberStr(index) }}
      </td>
      <td class="text-right">
        {{ restoration.Id }}
      </td>
      <td>
        {{ getMomentStr(restoration.Ctime) }}
      </td>
      <td class="custom-code">
        <span
            v-b-popover.click.top="restoration.ExtId"
            :class="getIdClass(restoration.ExtId)"
          >
          {{ getVisibleId(restoration.ExtId) }}
        </span>
      </td>
      <td>
        <player-link-optional
          :linkRequired="restoration.PlayerId !== playerId"
          :playerId="restoration.PlayerId"
          label="игрок"
        />
      </td>
      <td>{{ getInitiatorDataActionName(restoration.KeepMyData) }}</td>
      <td>
        {{ getClientIdentityTypeName(restoration.IdType) }}
      </td>
      <td class="custom-code">
        <span
            v-b-popover.click.top="getFullIdForPopover(restoration.IdVal)"
            :class="getIdClass(restoration.IdVal)"
          >
          {{ getVisibleId(restoration.IdVal) }}
        </span>
      </td>
      <td>
        <player-link-optional
          :linkRequired="restoration.TargetId !== playerId"
          :playerId="restoration.TargetId"
          label="игрок"
        />
      </td>
    </tr>
  </table>
</template>

<script>

import { CLIENT_IDENTITY_TYPE_EXT_ID } from '../model/player.js';
import { getClientIdentityTypeName   } from '../model/player.js';

import { getFormattedNumber  } from '../util.js';
import { getMomentStr        } from '../util.js';
import { createShortExtIdMap } from '../util.js';

import PlayerLinkOptional from './PlayerLinkOptional.vue';

export default {
  name: 'PlayerRestorationsTable',

  components: {
    PlayerLinkOptional,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    restorations: {
      type: Array,
      required: true,
    },
  },

  computed: {
    shortExtIdMap() {
      const m = createShortExtIdMap(this.realExtIds);
      return m;
    },

    realExtIds() {
      const extIds = [];

      for(const r of this.restorations) {
        if(isRealExtId(r.ExtId) && !extIds.includes(r.ExtId)) {
          extIds.push(r.ExtId);
        }
        if((r.IdType === CLIENT_IDENTITY_TYPE_EXT_ID) && isRealExtId(r.IdVal) && !extIds.includes(r.IdVal)) {
          extIds.push(r.IdVal);
        }
      }

      return extIds;
    },
  },

  methods: {
    /**
     * @param {number} index 
     * @returns {string}
     */
    getEventNumberStr(index) {
      const eventNumber = this.restorations.length - index;
      return getFormattedNumber(eventNumber);
    },

    /**
     * @param {boolean} keepData 
     * @returns {string}
     */
    getInitiatorDataActionName(keepData) {
      return keepData ? 'сохранено' : 'удалено';
    },

    getClientIdentityTypeName,
    getMomentStr,

    getVisibleId(id) {
      const shortId = this.shortExtIdMap.get(id)
      if(shortId === undefined) {
        return id;
      }

      return shortId + '…';
    },

    getFullIdForPopover(fullId) {
      if(this.canShort(fullId)) {
        return fullId;
      }

      return null;
    },

    canShort(fullId) {
      return this.shortExtIdMap.has(fullId)
    },

    getIdClass(fullId) {
      return {
        'tooltip-button': this.canShort(fullId),
      };
    },
  },

}

function isRealExtId(extId) {
  const forcedExtIdIdentityPrefix = 'InsiderExtId_';
  const isInsiderExtId = extId.startsWith(forcedExtIdIdentityPrefix);
  return !isInsiderExtId;
}
</script>

<style scoped>
.restorations-table {
  width: 1px;
}

.tooltip-button {
  /*text-decoration: underline;*/
  cursor: pointer;
}

.popover {
  max-width: 800px;
  font-family: monospace;
}
</style>
